<template>
  <div class="lz-field">
    <label class="lz-field-label" for="amountVal"
      >Amount
      <b-icon
        icon="info-circle-fill"
        class="lz-hint-icon"
        id="amountInfo"></b-icon>
    </label>
    <div class="lz-amount-input-group">
      <input
        type="number"
        class="form-control"
        :placeholder="amount"
        :value="amount"
        id="amountVal"
        max="9999.99"
        @change="amountChanged" />
      <CurrencySelector />
    </div>
    <b-popover
      target="amountInfo"
      triggers="hover focus"
      placement="bottom"
      content="Please enter the amount excluding any VAT. VAT is only applicable for UK expenses"></b-popover>
  </div>
</template>

<script>
import CurrencySelector from './CurrencySelector.vue'

export default {
  name: 'AmountSelector',
  components: { CurrencySelector },
  data() {
    return {
      approxGBPRate: '',
      gbpRates: { eur: 0, usd: 0 }
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    amount() {
      return this.FormData.amount
    },
    vat() {
      return this.FormData.vat
    },
    currency() {
      return this.FormData.currency
    }
  },
  // watch: {
  //   amount: {
  //     handler: 'amountChanged',
  //     immediate: true
  //   },
  //   currency: {
  //     handler: 'calcRates',
  //     immediate: true
  //   }
  // },
  // mounted() {
  //   // this.gbpRates = this.$cookies.get('__gbp-rates') || this.gbpRates
  //   // this.calcRates()
  // },
  methods: {
    amountChanged(ev) {
      const amount = ev?.target?.value ?? this.amount
      if (amount != this.amount) {
        this.$store.commit('setFormDataAmount', amount)
      }
    }
  }
}
</script>

<style scoped>
.lz-amount-input-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
.lz-amount-input-group input {
  min-width: 0;
  flex: 1 1 auto;
}
</style>
